import state from './userorg.state'
import mutations from './userorg.mutations'
import actions from './userorg.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
